/**
 * Fetches an array of freeGift settings from window.bt.settings and
 * builds an AJAX cart update payload with key=variantId and value=quantity.
 *
 */
export function getFreeGiftCartUpdate() {
  var quantity = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
  var _window$bt = window.bt,
      _window$bt$customer = _window$bt.customer;
  _window$bt$customer = _window$bt$customer === void 0 ? {} : _window$bt$customer;
  var _window$bt$customer$t = _window$bt$customer.tags,
      tags = _window$bt$customer$t === void 0 ? {} : _window$bt$customer$t,
      _window$bt$settings = _window$bt.settings;
  _window$bt$settings = _window$bt$settings === void 0 ? {} : _window$bt$settings;
  var _window$bt$settings$c = _window$bt$settings.checkout;
  _window$bt$settings$c = _window$bt$settings$c === void 0 ? {} : _window$bt$settings$c;
  var _window$bt$settings$c2 = _window$bt$settings$c.freeGifts,
      freeGifts = _window$bt$settings$c2 === void 0 ? [] : _window$bt$settings$c2;
  var freeGiftUpdateObject = {}; // Check for customer tags... and if they contain affiliate or employee we will not add free items.

  if (!(tags.includes('Employee') || tags.includes('Affiliate'))) {
    freeGifts.forEach(function (item) {
      freeGiftUpdateObject[item] = quantity;
    });
  }

  return freeGiftUpdateObject;
}